import { inject, Service } from '@angular/core';
import {
  BuildDepositInvoiceObjectRequestDtoInput,
  BuildInvoiceObjectRequestDtoInput,
  CreateCreditNoteRequestDtoInput,
  CreateWizardInvoiceRequestDtoInput,
  EInvoiceStatusEnumDto,
  GetNaturaTypesRequestDtoInput,
  GetNotIncludedDepositsRequestDtoInput,
  InvoiceGenerateProgressiveRequestDtoInput,
  QueryCheckFiscalDayNotClosedArgs,
  QueryInvoiceDtoInput,
  SavePrintedDocumentDataRequestDtoInput,
  SearchElectronicInvoiceDataPaginatedRequestDtoInput,
  UpsertInvoiceAdditionalProductDtoInput,
  UpsertInvoiceDataDtoInput,
  UpsertInvoiceDtoInput,
} from '@h5s/dtos-api';
import {
  BuildCreditNote,
  BuildCreditNoteGql,
  BuildCreditNoteQueryResult,
  BuildCreditNoteQueryVariables,
  BuildDepositInvoiceObjectGql,
  BuildDepositInvoiceObjectQueryResult,
  BuildDepositInvoiceObjectQueryVariables,
  BuildDepositInvoiceRequest,
  BuildInvoiceObjectGql,
  BuildInvoiceObjectQueryResult,
  BuildInvoiceObjectQueryVariables,
  BuildInvoiceRequest,
  CalculateCityTaxByListGql,
  CalculateCityTaxByListQueryResult,
  CalculateCityTaxByListQueryVariables,
  CalculateCityTaxGql,
  CalculateCityTaxQueryResult,
  CalculateCityTaxQueryVariables,
  CheckAskHolderGql,
  CheckAskHolderQueryResult,
  CheckAskHolderQueryVariables,
  CheckFiscalDayNotClosedGql,
  CheckFiscalDayNotClosedQueryResult,
  CheckFiscalDayNotClosedQueryVariables,
  CreateCreditNoteGql,
  CreateCreditNoteMutationResult,
  CreateCreditNoteMutationVariables,
  CreateCreditNoteRequest,
  CreateInvoiceDataGql,
  CreateInvoiceDataMutationResult,
  CreateInvoiceDataMutationVariables,
  CreateInvoiceGql,
  CreateInvoiceMutationResult,
  CreateInvoiceMutationVariables,
  CreateMasterInvoiceGql,
  CreateMasterInvoiceMutationResult,
  CreateMasterInvoiceMutationVariables,
  CreateMasterInvoiceResponse,
  CreateWizardInvoiceGql,
  CreateWizardInvoiceMutationResult,
  CreateWizardInvoiceMutationVariables,
  CreateWizardInvoiceRequest,
  CreateWizardInvoiceResponse,
  DeleteInvoiceGql,
  DeleteInvoiceMutationResult,
  DeleteInvoiceMutationVariables,
  DeleteMasterInvoiceGql,
  DeleteMasterInvoiceMutationResult,
  DeleteMasterInvoiceMutationVariables,
  Deposit,
  EInvoiceStatus,
  ElectronicInvoiceDataListPaginated,
  GeneratedInvoicedCityTax,
  GetActiveInvoiceBlocksGql,
  GetActiveInvoiceBlocksQueryResult,
  GetAllInvoiceBlocksGql,
  GetAllInvoiceBlocksQueryResult,
  GetInvoiceDataFromInvoiceIdGql,
  GetInvoiceDataFromInvoiceIdQueryResult,
  GetInvoiceDataFromInvoiceIdQueryVariables,
  GetInvoiceGql,
  GetInvoiceHolderGql,
  GetInvoiceHolderQueryResult,
  GetInvoiceHolderQueryVariables,
  GetInvoiceQueryResult,
  GetInvoiceQueryVariables,
  GetLinkedInvoicesGql,
  GetLinkedInvoicesQueryResult,
  GetLinkedInvoicesQueryVariables,
  GetLinkedReceiptsGql,
  GetLinkedReceiptsQueryResult,
  GetLinkedReceiptsQueryVariables,
  GetNaturaTypesGql,
  GetNaturaTypesQueryResult,
  GetNaturaTypesQueryVariables,
  GetNotIncludedDepositsGql,
  GetNotIncludedDepositsQueryResult,
  GetNotIncludedDepositsQueryVariables,
  GetOpenSubAccountHoldersGql,
  GetOpenSubAccountHoldersQueryResult,
  GetOpenSubAccountHoldersQueryVariables,
  Invoice,
  InvoiceAdditionalProduct,
  InvoiceBlockRules,
  InvoiceCreditNoteListPaginated,
  InvoiceData,
  InvoiceDocumentType,
  InvoiceGenerateProgressiveGql,
  InvoiceGenerateProgressiveQueryResult,
  InvoiceGenerateProgressiveQueryVariables,
  InvoiceHolder,
  InvoiceListPaginated,
  InvoiceToDeposit,
  IsInvoiceAlreadyPrintedGql,
  IsInvoiceAlreadyPrintedQueryResult,
  IsInvoiceAlreadyPrintedQueryVariables,
  IsInvoiceDeletableGql,
  IsInvoiceDeletableQueryResult,
  IsInvoiceDeletableQueryVariables,
  LinkedCreditNoteInvoice,
  NaturaType,
  NaturaTypesRequest,
  NotIncludedDepositsRequest,
  QueryCheckFiscalDayNotClosed,
  QueryElectronicInvoiceData,
  QueryInvoice,
  QueryInvoiceGenerateProgressive,
  SavePrintedDocumentData,
  SavePrintedDocumentDataGql,
  SavePrintedDocumentDataMutationResult,
  SavePrintedDocumentDataMutationVariables,
  SearchElectronicInvoiceDataPaginatedGql,
  SearchElectronicInvoiceDataPaginatedQueryResult,
  SearchElectronicInvoiceDataPaginatedQueryVariables,
  SearchInvoiceCreditNotePaginatedGql,
  SearchInvoiceCreditNotePaginatedQueryResult,
  SearchInvoiceCreditNotePaginatedQueryVariables,
  SearchInvoiceGql,
  SearchInvoicePaginatedGql,
  SearchInvoicePaginatedQueryResult,
  SearchInvoicePaginatedQueryVariables,
  SearchInvoiceQueryResult,
  SearchInvoiceQueryVariables,
  SearchLinkedCreditNoteInvoiceGql,
  SearchLinkedCreditNoteInvoiceQueryResult,
  SearchLinkedCreditNoteInvoiceQueryVariables,
  SendAllResponse,
  SendElectronicInvoiceGql,
  SendElectronicInvoiceMutationResult,
  SendElectronicInvoiceMutationVariables,
  SendElectronicInvoicesGql,
  SendElectronicInvoicesMutationResult,
  SendElectronicInvoicesMutationVariables,
  UpdateInvoiceDataGql,
  UpdateInvoiceDataMutationResult,
  UpdateInvoiceDataMutationVariables,
  UpdateInvoiceGql,
  UpdateInvoiceMutationResult,
  UpdateInvoiceMutationVariables,
  UpdateMasterInvoiceGql,
  UpdateMasterInvoiceMutationResult,
  UpdateMasterInvoiceMutationVariables,
  UpdateStatusAllResponse,
  UpdateStatusElectronicInvoiceGql,
  UpdateStatusElectronicInvoiceMutationResult,
  UpdateStatusElectronicInvoiceMutationVariables,
  UpdateStatusElectronicInvoicesGql,
  UpdateStatusElectronicInvoicesMutationResult,
  UpdateStatusElectronicInvoicesMutationVariables,
  ValidateElectronicInvoice,
  ValidateElectronicInvoiceGql,
  ValidateElectronicInvoiceQueryResult,
  ValidateElectronicInvoiceQueryVariables,
} from '@h5s/entities';
import { getNullableValueOrError, getValueOrError, throwErrorIfNullFromGraphQL } from '@h5s/util-error';
import {
  mapArrayParamDto,
  mapArrayResponse,
  mapEnumArrayResponse,
  mapNullableResponse,
  mapParamDto,
  mapQueryParamDto,
  mapResponse,
} from '@h5s/util-object';
import { Apollo } from 'apollo-angular';
import { DateTime } from 'luxon';
import { map, Observable } from 'rxjs';

@Service()
export class DataAccessInvoiceService {
  private readonly apollo = inject(Apollo);

  /**
   * Ottiene una Invoice tramite ID.
   *
   * @param {number} id - ID dell'Invoice
   * @returns {Observable<Invoice>} Un observable che emette l'Invoice.
   */
  public getInvoice(id: number): Observable<Invoice> {
    const variables: GetInvoiceQueryVariables = {
      id,
    };

    return this.apollo
      .query<GetInvoiceQueryResult>({
        query: GetInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(Invoice, result.getInvoice)),
      );
  }

  /**
   * Cerca Invoice paginate in base ai parametri forniti.
   */
  public searchInvoicePaginated(queryInvoice: QueryInvoice): Observable<InvoiceListPaginated> {
    const queryInvoiceDTO = mapQueryParamDto<QueryInvoiceDtoInput>(queryInvoice);

    const variables: SearchInvoicePaginatedQueryVariables = {
      queryInvoiceDTO,
    };

    return this.apollo
      .query<SearchInvoicePaginatedQueryResult>({
        query: SearchInvoicePaginatedGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(InvoiceListPaginated, result.searchInvoicePaginated)),
      );
  }

  /**
   * Cerca ElectronicInvoiceData paginate in base ai parametri forniti.
   */
  public searchElectronicInvoiceDataPaginated(
    queryElectronicInvoiceData: QueryElectronicInvoiceData,
  ): Observable<ElectronicInvoiceDataListPaginated> {
    const searchElectronicInvoiceDataPaginatedRequestDTO =
      mapQueryParamDto<SearchElectronicInvoiceDataPaginatedRequestDtoInput>(queryElectronicInvoiceData);

    const variables: SearchElectronicInvoiceDataPaginatedQueryVariables = {
      searchElectronicInvoiceDataPaginatedRequestDTO,
    };

    return this.apollo
      .query<SearchElectronicInvoiceDataPaginatedQueryResult>({
        query: SearchElectronicInvoiceDataPaginatedGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(ElectronicInvoiceDataListPaginated, result.searchElectronicInvoiceDataPaginated)),
      );
  }

  /**
   * Cerca InvoiceCreditNote paginate in base ai parametri forniti.
   */
  public searchInvoiceCreditNotePaginated(
    queryInvoiceCreditNote: QueryInvoice,
  ): Observable<InvoiceCreditNoteListPaginated> {
    const queryInvoiceDTO = mapQueryParamDto<QueryInvoiceDtoInput>(queryInvoiceCreditNote);

    const variables: SearchInvoiceCreditNotePaginatedQueryVariables = {
      queryInvoiceDTO,
    };

    return this.apollo
      .query<SearchInvoiceCreditNotePaginatedQueryResult>({
        query: SearchInvoiceCreditNotePaginatedGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(InvoiceCreditNoteListPaginated, result.searchInvoicePaginated)),
      );
  }

  /**
   * Ricerca uno o più invoice.
   *
   * @param {QueryInvoice} queryInvoice
   * @returns {Observable<Invoice[]>}
   */
  public searchInvoice(queryInvoice: QueryInvoice): Observable<Invoice[]> {
    const queryInvoiceDTO = mapQueryParamDto<QueryInvoiceDtoInput>(queryInvoice);

    const variables: SearchInvoiceQueryVariables = {
      queryInvoiceDTO,
    };

    return this.apollo
      .query<SearchInvoiceQueryResult>({
        query: SearchInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(Invoice, result.searchInvoice)),
      );
  }

  /**
   * Dato l'id di una invoice cerca se ci sono delle note di credito collegate a quella invoice e le ritorna.
   *
   * @param {number} creditNoteInvoiceId
   * @returns {Observable<LinkedCreditNoteInvoice[]>}
   *
   */
  public searchLinkedCreditNoteInvoice(creditNoteInvoiceId: number): Observable<LinkedCreditNoteInvoice[]> {
    const queryInvoice = new QueryInvoice({ creditNoteInvoiceId });
    const queryInvoiceDTO = mapQueryParamDto<QueryInvoiceDtoInput>(queryInvoice);

    const variables: SearchLinkedCreditNoteInvoiceQueryVariables = {
      queryInvoiceDTO,
    };

    return this.apollo
      .query<SearchLinkedCreditNoteInvoiceQueryResult>({
        query: SearchLinkedCreditNoteInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(LinkedCreditNoteInvoice, result.searchInvoice)),
      );
  }

  /**
   * Ricerca una InvoiceData dato un invoiceId
   *
   * @param {number} invoiceId
   * @returns {Observable<InvoiceData | null>}
   */
  public getInvoiceData(invoiceId: number): Observable<InvoiceData | null> {
    const variables: GetInvoiceDataFromInvoiceIdQueryVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .query<GetInvoiceDataFromInvoiceIdQueryResult>({
        query: GetInvoiceDataFromInvoiceIdGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapNullableResponse(InvoiceData, result.getInvoiceDataFromInvoiceId)),
      );
  }

  public validateElectronicInvoice(invoiceId: number): Observable<ValidateElectronicInvoice> {
    const variables: ValidateElectronicInvoiceQueryVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .query<ValidateElectronicInvoiceQueryResult>({
        query: ValidateElectronicInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(ValidateElectronicInvoice, result.validateElectronicInvoice)),
      );
  }

  /**
   * Modifica il conto
   *
   * @param {Invoice} invoice
   * @param {InvoiceAdditionalProduct[]} additionalProducts
   * @returns
   */
  public updateInvoice(invoice: Invoice, additionalProducts: InvoiceAdditionalProduct[]): Observable<boolean> {
    const upsertInvoice = invoice.toUpsertInvoice();

    const upsertInvoiceDTO = mapParamDto<UpsertInvoiceDtoInput>(upsertInvoice);
    const upsertInvoiceAdditionalProductDTO =
      mapArrayParamDto<UpsertInvoiceAdditionalProductDtoInput>(additionalProducts);

    const variables: UpdateInvoiceMutationVariables = {
      upsertInvoiceDTO,
      additionalProducts: upsertInvoiceAdditionalProductDTO,
    };

    return this.apollo
      .mutate<UpdateInvoiceMutationResult>({
        mutation: UpdateInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.updateInvoice),
      );
  }

  /**
   * Crea un conto
   *
   * @param {invoice} invoice
   * @param {InvoiceAdditionalProduct[]} additionalProducts
   * @returns
   */
  public createInvoice(invoice: Invoice, additionalProducts: InvoiceAdditionalProduct[]): Observable<number> {
    const upsertInvoice = invoice.toUpsertInvoice();

    const upsertInvoiceDTO = mapParamDto<UpsertInvoiceDtoInput>(upsertInvoice);
    const upsertInvoiceAdditionalProductDTO =
      mapArrayParamDto<UpsertInvoiceAdditionalProductDtoInput>(additionalProducts);

    const variables: CreateInvoiceMutationVariables = {
      upsertInvoiceDTO,
      additionalProducts: upsertInvoiceAdditionalProductDTO,
    };

    return this.apollo
      .mutate<CreateInvoiceMutationResult>({
        mutation: CreateInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => getValueOrError(result.createInvoice)),
      );
  }

  /**
   * Genera un nuovo progressivo
   *
   * @param {string | null} block
   * @param {InvoiceDocumentType} documentType
   * @param {string | undefined} invoiceType
   * @returns
   */
  public generateProgressive(
    block: string | null,
    documentType: InvoiceDocumentType,
    invoiceType: string | null,
  ): Observable<number> {
    const queryInvoiceGenerateProgressive = new QueryInvoiceGenerateProgressive();
    queryInvoiceGenerateProgressive.block = block;
    queryInvoiceGenerateProgressive.documentType = documentType;
    queryInvoiceGenerateProgressive.invoiceType = invoiceType;

    const variables: InvoiceGenerateProgressiveQueryVariables = {
      invoiceGenerateProgressiveRequestDTO: mapQueryParamDto<InvoiceGenerateProgressiveRequestDtoInput>(
        queryInvoiceGenerateProgressive,
      ),
    };

    return this.apollo
      .query<InvoiceGenerateProgressiveQueryResult>({
        query: InvoiceGenerateProgressiveGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => getValueOrError(result.invoiceGenerateProgressive, 'Progressive is null')),
      );
  }

  /**
   * Ottiene la lista di tutti i blocchi di fatturazione
   * Da usare dove l'utente deve poter scegliere tra tutti i blocchi di fatturazione, indipendentemente dal fatto che siano attivi o meno
   *
   * @returns {Observable<InvoiceBlockRules>}
   */
  public getAllInvoiceBlocks(): Observable<InvoiceBlockRules> {
    return this.apollo
      .query<GetAllInvoiceBlocksQueryResult>({
        query: GetAllInvoiceBlocksGql,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.getAllInvoiceBlocks),
      );
  }

  /**
   * Ottiene la lista dei blocchi di fatturazione attivi
   * Da usare dove l'utente deve poter scegliere solo tra i blocchi di fatturazione attivi
   * Come ad esempio nella creazione del conto, NdC, conto passante e stampanti
   *
   * @returns {Observable<InvoiceBlockRules>}
   */
  public getActiveInvoiceBlocks(): Observable<InvoiceBlockRules> {
    return this.apollo
      .query<GetActiveInvoiceBlocksQueryResult>({
        query: GetActiveInvoiceBlocksGql,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(InvoiceBlockRules, result.getActiveInvoiceBlocks)),
      );
  }

  /**
   * Ottiene la lista di invoice collegati ad un master invoice.
   *
   * @param {number} invoiceId InvoiceId
   * @returns {Observable<Invoice[]>} Lista di documenti collegati
   */
  public getLinkedReceipts(invoiceId: number): Observable<Invoice[]> {
    const variables: GetLinkedReceiptsQueryVariables = {
      masterInvoiceId: invoiceId,
    };

    return this.apollo
      .query<GetLinkedReceiptsQueryResult>({
        query: GetLinkedReceiptsGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(Invoice, result.getLinkedReceipts)),
      );
  }

  /**
   * Ottiene la lista di tasse di soggiorno da aggiungere al purchased stay
   *
   * @param {number} purchasedStayId IdSoggiorno
   * @returns {Observable<GeneratedInvoicedCityTax[]>} Lista di tasse di soggiorno
   */
  public calculateCityTax(purchasedStayId: number): Observable<GeneratedInvoicedCityTax[]> {
    const variables: CalculateCityTaxQueryVariables = {
      purchasedStayId: purchasedStayId,
    };

    return this.apollo
      .query<CalculateCityTaxQueryResult>({
        query: CalculateCityTaxGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(GeneratedInvoicedCityTax, result.calculateCityTax)),
      );
  }

  /**
   * Ottiene la lista di tasse di soggiorno da aggiungere al purchased stay
   *
   * @param {number} purchasedStayIds IdsSoggiorno
   * @returns {Observable<GeneratedInvoicedCityTax[]>} Lista di tasse di soggiorno
   */
  public calculateCityTaxByList(purchasedStayIds: number[]): Observable<GeneratedInvoicedCityTax[]> {
    const variables: CalculateCityTaxByListQueryVariables = {
      purchasedStayIds: purchasedStayIds,
    };

    return this.apollo
      .query<CalculateCityTaxByListQueryResult>({
        query: CalculateCityTaxByListGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(GeneratedInvoicedCityTax, result.calculateCityTaxByList)),
      );
  }

  /**
   * Controlla se il conto può essere cancellato
   *
   * @param {number} invoiceId
   */
  public isDeletable(invoiceId: number): Observable<boolean> {
    const variables: IsInvoiceDeletableQueryVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .query<IsInvoiceDeletableQueryResult>({
        query: IsInvoiceDeletableGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.isInvoiceDeletable),
      );
  }

  /**
   * Controlla se il conto è già stato stampato
   *
   * @param {number} invoiceId
   */
  public isAlreadyPrinted(invoiceId: number): Observable<boolean> {
    const variables: IsInvoiceAlreadyPrintedQueryVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .query<IsInvoiceAlreadyPrintedQueryResult>({
        query: IsInvoiceAlreadyPrintedGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.isInvoiceAlreadyPrinted),
      );
  }

  /**
   * Elimina il conto
   *
   * @param {number} invoiceId
   */
  public deleteInvoice(invoiceId: number): Observable<boolean> {
    const variables: DeleteInvoiceMutationVariables = {
      id: invoiceId,
    };

    return this.apollo
      .mutate<DeleteInvoiceMutationResult>({
        mutation: DeleteInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.deleteInvoice),
      );
  }

  /**
   * Controlla se il giorno fiscale non è chiuso, SOLO per fisco francese (owner.nf525 = true)
   * Se non è chiuso l'API ritorna un USER_FACING_ERROR con il messaggio di errore
   *
   * Altrimenti ritorna TRUE e si prosegue l'esecuzione, NON BLOCCANTE
   *
   * @param {InvoiceDocumentType} documentType
   * @param {DateTime} ownerCorporateDataId
   * @param {number} invoiceDate
   */
  public checkFiscalDayNotClosed(
    documentType: InvoiceDocumentType,
    invoiceDate: DateTime | null,
    ownerCorporateDataId: number,
  ): Observable<boolean> {
    const queryCheckFiscalDayNotClosed = new QueryCheckFiscalDayNotClosed();
    queryCheckFiscalDayNotClosed.documentType = documentType;
    queryCheckFiscalDayNotClosed.invoiceDate = invoiceDate;
    queryCheckFiscalDayNotClosed.ownerCorporateDataId = ownerCorporateDataId;

    const queryCheckFiscalDayNotClosedArgs =
      mapQueryParamDto<QueryCheckFiscalDayNotClosedArgs>(queryCheckFiscalDayNotClosed);

    const variables: CheckFiscalDayNotClosedQueryVariables = {
      ownerCorporateDataId: queryCheckFiscalDayNotClosedArgs.ownerCorporateDataId,
      documentType: queryCheckFiscalDayNotClosedArgs.documentType,
      invoiceDate: queryCheckFiscalDayNotClosedArgs.invoiceDate,
    };

    return this.apollo
      .query<CheckFiscalDayNotClosedQueryResult>({
        query: CheckFiscalDayNotClosedGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.checkFiscalDayNotClosed),
      );
  }

  /**
   * Carica gli invoice collegati al deposito
   */
  public getLinkedInvoices(depositId: number): Observable<InvoiceToDeposit[]> {
    const variables: GetLinkedInvoicesQueryVariables = {
      depositId: depositId,
    };

    return this.apollo
      .query<GetLinkedInvoicesQueryResult>({
        query: GetLinkedInvoicesGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(InvoiceToDeposit, result.getLinkedInvoices)),
      );
  }

  /**
   * Carica la lista di intestatari di sottoconti della prenotazione
   *
   * @param reservationId Id prenotazione da controllare
   * @returns Observable di intestatari di sottoconti
   */
  public getOpenSubAccountHolders(reservationId: number): Observable<InvoiceHolder[]> {
    const variables: GetOpenSubAccountHoldersQueryVariables = {
      reservationId: reservationId,
    };

    return this.apollo
      .query<GetOpenSubAccountHoldersQueryResult>({
        query: GetOpenSubAccountHoldersGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(InvoiceHolder, result.getOpenSubAccountHolders)),
      );
  }

  /**
   * Effettua la chiamata per sapere se mostrare la modale di generazione del documento o meno
   *
   * @param reservationId Id prenotazione da controllare
   * @param purchasedStayId Id soggiorno da controllare
   * @returns Observable del risultato
   */
  public checkAskHolder(reservationId: number, purchasedStayId: number | null): Observable<boolean> {
    const variables: CheckAskHolderQueryVariables = {
      reservationId: reservationId,
      purchasedStayId: purchasedStayId,
    };

    return this.apollo
      .query<CheckAskHolderQueryResult>({
        query: CheckAskHolderGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.checkAskHolder),
      );
  }

  /**
   * Ritorna un nuovo documento, generato coi parametri impostati
   *
   * @param params Parametri per la generazione del nuovo documento
   * @returns Observable di invoice
   */
  public buildInvoiceObject(params: BuildInvoiceRequest): Observable<Invoice> {
    const request = mapParamDto<BuildInvoiceObjectRequestDtoInput>(params);

    const variables: BuildInvoiceObjectQueryVariables = {
      request: request,
    };

    return this.apollo
      .query<BuildInvoiceObjectQueryResult>({
        query: BuildInvoiceObjectGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(Invoice, result.buildInvoiceObject, true)),
      );
  }

  /**
   * Ritorna un nuovo documento, generato coi parametri impostati
   *
   * @param params Parametri per la generazione del nuovo documento
   * @returns Observable di invoice
   */
  public buildDepositInvoiceObject(params: BuildDepositInvoiceRequest): Observable<Invoice> {
    const request = mapParamDto<BuildDepositInvoiceObjectRequestDtoInput>(params);

    const variables: BuildDepositInvoiceObjectQueryVariables = {
      request: request,
    };

    return this.apollo
      .query<BuildDepositInvoiceObjectQueryResult>({
        query: BuildDepositInvoiceObjectGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(Invoice, result.buildDepositInvoiceObject, true)),
      );
  }

  /** Ritorna i dati necessari per costruire la wizard di creazione nota di credito */
  public buildCreditNote(invoiceId: number): Observable<BuildCreditNote> {
    const variables: BuildCreditNoteQueryVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .query<BuildCreditNoteQueryResult>({
        query: BuildCreditNoteGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(BuildCreditNote, result.buildCreditNote, true)),
      );
  }

  public getNotIncludedDeposits(notIncludedDepositsParams: NotIncludedDepositsRequest): Observable<Deposit[]> {
    const request = mapParamDto<GetNotIncludedDepositsRequestDtoInput>(notIncludedDepositsParams);

    const variables: GetNotIncludedDepositsQueryVariables = {
      getNotIncludedDepositsRequestDTO: request,
    };

    return this.apollo
      .query<GetNotIncludedDepositsQueryResult>({
        query: GetNotIncludedDepositsGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapArrayResponse(Deposit, result.getNotIncludedDeposits, true)),
      );
  }

  public updateElectronicInvoiceSendStatus(invoiceId: number): Observable<EInvoiceStatus | null> {
    const variables: UpdateStatusElectronicInvoiceMutationVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .mutate<UpdateStatusElectronicInvoiceMutationResult>({
        mutation: UpdateStatusElectronicInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => getNullableValueOrError(result.updateStatusElectronicInvoice)),
        map((result) => (result ? this.mapEInvoiceStatusEnumDtoToModel(result) : result)),
      );
  }

  public updateElectronicInvoicesSendStatus(invoiceIds: number[]): Observable<UpdateStatusAllResponse> {
    const variables: UpdateStatusElectronicInvoicesMutationVariables = {
      invoiceIds,
    };

    return this.apollo
      .mutate<UpdateStatusElectronicInvoicesMutationResult>({
        mutation: UpdateStatusElectronicInvoicesGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(UpdateStatusAllResponse, result.updateStatusElectronicInvoices)),
      );
  }

  private mapEInvoiceStatusEnumDtoToModel(dto: EInvoiceStatusEnumDto): EInvoiceStatus {
    switch (dto) {
      case EInvoiceStatusEnumDto.AccettataCommittente:
        return EInvoiceStatus.AccettataCommittente;

      case EInvoiceStatusEnumDto.Archivio:
        return EInvoiceStatus.Archivio;

      case EInvoiceStatusEnumDto.Attesa:
        return EInvoiceStatus.Attesa;

      case EInvoiceStatusEnumDto.ConsegnatoDestinatario:
        return EInvoiceStatus.ConsegnatoDestinatario;

      case EInvoiceStatusEnumDto.DaInviare:
        return EInvoiceStatus.DaInviare;

      case EInvoiceStatusEnumDto.DecorrenzaTermini:
        return EInvoiceStatus.DecorrenzaTermini;

      case EInvoiceStatusEnumDto.ImpossibileRecapitare:
        return EInvoiceStatus.ImpossibileRecapitare;

      case EInvoiceStatusEnumDto.InviataCommittenteEMail:
        return EInvoiceStatus.InviataCommittenteEMail;

      case EInvoiceStatusEnumDto.InviatoSdi:
        return EInvoiceStatus.InviatoSdi;

      case EInvoiceStatusEnumDto.MancataConsegna:
        return EInvoiceStatus.MancataConsegna;

      case EInvoiceStatusEnumDto.RifiutataCommittente:
        return EInvoiceStatus.RifiutataCommittente;

      case EInvoiceStatusEnumDto.ScartoSdi:
        return EInvoiceStatus.ScartoSdi;

      case EInvoiceStatusEnumDto.Sconosciuto:
        return EInvoiceStatus.Sconosciuto;
    }
  }

  /**
   * Invia la fattura elettronica all'SDI
   */
  public sendElectronicInvoice(invoiceId: number): Observable<boolean> {
    const variables: SendElectronicInvoiceMutationVariables = {
      invoiceId: invoiceId,
    };

    return this.apollo
      .mutate<SendElectronicInvoiceMutationResult>({
        mutation: SendElectronicInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.sendElectronicInvoice),
      );
  }
  /**
   * Invia le fatture elettroniche all'SDI
   */
  public sendElectronicInvoices(invoiceIds: number[]): Observable<SendAllResponse> {
    const variables: SendElectronicInvoicesMutationVariables = {
      invoiceIds,
    };

    return this.apollo
      .mutate<SendElectronicInvoicesMutationResult>({
        mutation: SendElectronicInvoicesGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(SendAllResponse, result.sendElectronicInvoices)),
      );
  }

  public updateInvoiceData(invoiceData: InvoiceData): Observable<boolean> {
    const variables: UpdateInvoiceDataMutationVariables = {
      upsertInvoiceDataDTO: mapParamDto<UpsertInvoiceDataDtoInput>(invoiceData),
    };

    return this.apollo
      .mutate<UpdateInvoiceDataMutationResult>({
        mutation: UpdateInvoiceDataGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.updateInvoiceData),
      );
  }

  public createInvoiceData(invoiceData: InvoiceData): Observable<number> {
    const variables: CreateInvoiceDataMutationVariables = {
      upsertInvoiceDataDTO: mapParamDto<UpsertInvoiceDataDtoInput>(invoiceData, null, true),
    };

    return this.apollo
      .mutate<CreateInvoiceDataMutationResult>({
        mutation: CreateInvoiceDataGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data?.createInvoiceData),
        map((result) => result),
      );
  }

  public savePrintedDocumentData(printedDocumentData: SavePrintedDocumentData): Observable<boolean> {
    const variables: SavePrintedDocumentDataMutationVariables = {
      saveCashRegisterPrintRequestDTO: mapParamDto<SavePrintedDocumentDataRequestDtoInput>(printedDocumentData),
    };

    return this.apollo
      .mutate<SavePrintedDocumentDataMutationResult>({
        mutation: SavePrintedDocumentDataGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.savePrintedDocumentData),
      );
  }

  public getInvoiceHolder(invoiceHolderId: number): Observable<InvoiceHolder> {
    const variables: GetInvoiceHolderQueryVariables = {
      id: invoiceHolderId,
    };

    return this.apollo
      .query<GetInvoiceHolderQueryResult>({
        query: GetInvoiceHolderGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data?.getInvoiceHolder),
        map((result) => mapResponse(InvoiceHolder, result)),
      );
  }

  /**
   * Crea un conto passante
   *
   * @param {CreateWizardInvoiceRequest} params

   * @returns {CreateWizardInvoiceResponse}
   */
  public createWizardInvoice(params: CreateWizardInvoiceRequest): Observable<CreateWizardInvoiceResponse> {
    const request = mapParamDto<CreateWizardInvoiceRequestDtoInput>(params);

    const variables: CreateWizardInvoiceMutationVariables = {
      request,
    };

    return this.apollo
      .mutate<CreateWizardInvoiceMutationResult>({
        mutation: CreateWizardInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(CreateWizardInvoiceResponse, result.createWizardInvoice)),
      );
  }

  /**
   * Crea una nota di credito
   */
  public createCreditNote(params: CreateCreditNoteRequest): Observable<number> {
    const request = mapParamDto<CreateCreditNoteRequestDtoInput>(params);

    const variables: CreateCreditNoteMutationVariables = {
      request,
    };

    return this.apollo
      .mutate<CreateCreditNoteMutationResult>({
        mutation: CreateCreditNoteGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => result.createCreditNote),
      );
  }

  /**
   * Ottiene la lista delle tipologie di esenzione iva (natura)
   */
  public getNaturaTypes(params: NaturaTypesRequest): Observable<NaturaType[]> {
    const request = mapParamDto<GetNaturaTypesRequestDtoInput>(params);

    const variables: GetNaturaTypesQueryVariables = {
      request,
    };

    return this.apollo
      .query<GetNaturaTypesQueryResult>({
        query: GetNaturaTypesGql,
        variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapEnumArrayResponse(NaturaType, result.getNaturaTypes)),
      );
  }

  public createMasterInvoice(invoice: Invoice, linkedReceiptIds: number[]): Observable<CreateMasterInvoiceResponse> {
    const upsertInvoice = invoice.toUpsertInvoice();
    const upsertInvoiceDto = mapParamDto<UpsertInvoiceDtoInput>(upsertInvoice);

    const variables: CreateMasterInvoiceMutationVariables = {
      upsertInvoiceDTO: upsertInvoiceDto,
      linkedReceiptIds: linkedReceiptIds,
    };

    return this.apollo
      .mutate<CreateMasterInvoiceMutationResult>({
        mutation: CreateMasterInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => mapResponse(CreateMasterInvoiceResponse, result.createMasterInvoice)),
      );
  }

  public updateMasterInvoice(invoice: Invoice, linkedReceiptIds: number[]): Observable<boolean> {
    const upsertInvoice = invoice.toUpsertInvoice();
    const upsertInvoiceDto = mapParamDto<UpsertInvoiceDtoInput>(upsertInvoice);

    const variables: UpdateMasterInvoiceMutationVariables = {
      upsertInvoiceDTO: upsertInvoiceDto,
      linkedReceiptIds: linkedReceiptIds,
    };

    return this.apollo
      .mutate<UpdateMasterInvoiceMutationResult>({
        mutation: UpdateMasterInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => getValueOrError(result.updateMasterInvoice)),
      );
  }

  public deleteMasterInvoice(invoiceId: number): Observable<boolean> {
    const variables: DeleteMasterInvoiceMutationVariables = {
      id: invoiceId,
    };

    return this.apollo
      .mutate<DeleteMasterInvoiceMutationResult>({
        mutation: DeleteMasterInvoiceGql,
        variables: variables,
      })
      .pipe(
        throwErrorIfNullFromGraphQL((data) => data),
        map((result) => getValueOrError(result.deleteMasterInvoice)),
      );
  }
}
